module.exports = __webpack_public_path__ + "img/thumbnail_Emu_m_normal.e6508694.png";